import { render, staticRenderFns } from "./FilesNavbar.vue?vue&type=template&id=94aaceec&"
import script from "./FilesNavbar.vue?vue&type=script&lang=js&"
export * from "./FilesNavbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports